import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {InfoPageService} from "../../info-pages/info-page.service";
import {CmsHtmlPage} from "../../info-pages/cms-html-page";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AppConfigService} from "../../config/app-config.service";
import {HtmlUtilsService} from "../../html-utils/html-utils.service";
import {TranslateService} from "../../shared/translate.service";

@Component({
  selector: 'app-footer-link',
  templateUrl: './footer-link.component.html',
  styleUrls: ['./footer-link.component.scss']
})
export class FooterLinkComponent implements OnInit {

  @Input() config: CmsHtmlPage;

  @Input() isMobile: boolean;

  constructor(private router: Router,
              private modalService: NgbModal,
              private appConfig: AppConfigService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
  }

  public navigateTo(): void {
    const url = this.createUrl(this.config);
    if (this.config.modal) {
      const modalInstance = this.modalService.open(this.appConfig.modalClasses.get(this.config.componentName));
      this.config.additionalParameters.forEach(value => {
        Object.keys(value).forEach(key => {
          modalInstance.componentInstance[key] = value[key];
        })
      })
    } else {
      if (FooterLinkComponent.hasExternalUrl(this.config)) {
        if(this.config.newWindow){
          window.open(url);
        }
        else {
          window.location.href = url;
        }
      } else {
        if(this.config.newWindow){
          window.open(url);
        }
        else {
          this.router.navigateByUrl(url);
        }
      }
    }
  }

  private createUrl(htmlPage: CmsHtmlPage): string | undefined{
    if(htmlPage){
      if(FooterLinkComponent.hasExternalUrl(htmlPage)){
        if (this.translateService.language.toLowerCase() === 'en') {
          return HtmlUtilsService.createUrl(htmlPage.externalUrl.en);
        } else {
          return HtmlUtilsService.createUrl(htmlPage.externalUrl.pl);
        }
      }
      else {
        if(htmlPage.componentName && htmlPage.componentName === 'main') {
          return '/' + `${this.config.alias}`;
        } else {
          return '/' + InfoPageService.BASE_PREFIX + `/${this.config.alias}`;
        }
      }
    }
    return undefined;
  }

  private static hasExternalUrl(config: CmsHtmlPage): boolean{
    return config.externalUrl !== null;
  }
}
